import { useIntl } from "react-intl";
import { SYMBOL_TOGGLE_STROKE } from "@/components/design/symbol-toggle";
import { Button } from "@/components/design/Button";
import { useAgentStore } from "@/stores/agent-store";
import { ACCENT_PRESSED } from "./accent-pressed";

// One globe for the drawer and the Studio notebook: both switch the same state, so the choice holds wherever
// the next question is asked. The drawer stays mounted, so a second place needs its own id.
export function WebSearchToggle({ id = "agent-web-search-toggle", disabled = false }: { id?: string; disabled?: boolean }) {
  const intl = useIntl();
  // The globe opens the web; on while any source is picked, so in the Studio it also shows PubMed chosen there,
  // and a click then closes that too. The agent-service searches only what the admin offers; off, nothing goes out.
  const source = useAgentStore((s) => s.searchSource);
  const setSearchSource = useAgentStore((s) => s.setSearchSource);
  const enabled = source !== null;
  return (
    <Button
      id={id}
      variant="icon"
      aria-label={intl.formatMessage({ id: "agent.webSearch.label", defaultMessage: "Web search" })}
      aria-pressed={enabled}
      title={source === "pubmed"
        ? intl.formatMessage({ id: "agent.webSearch.onPubmed", defaultMessage: "PubMed search on: your next message is searched in PubMed, then it turns off again." })
        : enabled
          ? intl.formatMessage({ id: "agent.webSearch.on", defaultMessage: "Web search on: your next message is searched online, then it turns off again." })
          : intl.formatMessage({ id: "agent.webSearch.off", defaultMessage: "Web search off. Click to search online." })}
      disabled={disabled}
      onClick={() => setSearchSource(enabled ? null : "web")}
      className="shrink-0"
      style={enabled ? ACCENT_PRESSED : undefined}
    >
      <svg aria-hidden="true" className={`h-5 w-5 ${enabled ? "stroke-accent-decoration" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={enabled ? SYMBOL_TOGGLE_STROKE.pressed : SYMBOL_TOGGLE_STROKE.normal}>
        <circle cx="12" cy="12" r="9" />
        <ellipse cx="12" cy="12" rx="4" ry="9" />
        <path d="M3 12h18M5 6.5h14M5 17.5h14" strokeLinecap="round" />
      </svg>
    </Button>
  );
}
